import { render, staticRenderFns } from "./Banana.vue?vue&type=template&id=fbcbe276&scoped=true"
import script from "./Banana.vue?vue&type=script&lang=js"
export * from "./Banana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcbe276",
  null
  
)

export default component.exports